module.exports = __webpack_public_path__ + "img/mail.5e7dfaf2.png";